<template>
  <el-dialog
    title=""
    :visible.sync="showFirstCharge"
    class="first-charge-wrapper"
    :before-close="goBack"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :modal-append-to-body="false"
    width="400px"
  >
    <div class="first-charge">
      <div class="top">
        <img class="top-title" src="./img/shouch_wenzi.png" alt="" />
      </div>
      <img class="bg-liwu" src="./img/shouch_liwu.png" alt="" />
      <div class="first-charge-content">
        <div class="gift-area">
          <div class="gift-item mr-20" v-for="item in giftList" :key="item.id">
            <div class="gift-img-item">
              <img class="gift-img" :src="item.url" alt="" />
              <p class="gift-info">
                <span class="gift-name">{{ item.name }}</span>
                <span class="gift-num">x{{ item.count }}</span>
              </p>
            </div>
          </div>
        </div>
        <div class="activity-btn" :style="{ opacity: isReceive == 3 ? 0.3 : 1 }" @click="toCharge">
          {{ btnText }}
        </div>
        <p class="activity-tips">活动最终解释权归猎鹰直播所有</p>
      </div>
      <div class="first-charge-rule">
        <div class="first-charge-rule-title">活动规则</div>
        <div class="first-charge-rule-content">
          <p>
            1.活动内容：活动期间用户登录账户，充值克拉币满6元即可完成充值活动任务并获得任务奖励。（注：仅限未充值的用户参与，每个真实IP用户最多可获得一次奖励）
          </p>
          <p>2.活动奖励内容：礼物（鹰钻：5个、来个角球：10个、666：10个、再进一球：4个）， 平台货币（克拉币：60个）。</p>
          <p>3.奖励发放时间：充值任务奖励将在充值完成后5分钟内自动发放到您的账户。</p>
          <p style="margin-top: 28px">补充说明：</p>
          <p>1.本活动仅可通过猎鹰直播官方充值渠道参与</p>
          <p>2.如遇用户通过非正常手段获取活动奖励，猎鹰直播有权取消活动资格，并收回已发放的奖励。</p>
          <p>3.活动最终解释权归猎鹰直播所有。</p>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { post } from "../../util/http";
export default {
  props: {
    showFirstCharge: {
      type: Boolean,
      default: false,
    },
    isReceive: {
      type: Number,
      default: 2,
    },
  },
  computed: {
    ...mapState(["userInfo"]),
    btnText() {
      let str = "";
      // 0、活动关闭 1、可以领取 2、未达领取条件 3已经领取
      if (this.isReceive == 0) {
        str = "活动已关闭";
      } else if (this.isReceive == 1) {
        str = "领取奖励";
      } else if (this.isReceive == 2) {
        str = "立即充值";
      } else if (this.isReceive == 3) {
        str = "已领取";
      }
      return str;
    },
  },
  data() {
    return {
      giftList: [
        {
          id: "10",
          name: "鹰钻",
          count: 10,
          url: require("./img/duye.png"),
        },
        {
          id: "20",
          name: "666",
          count: 10,
          url: require("./img/666.png"),
        },
        {
          id: "30",
          name: "再进一球",
          count: 4,
          url: require("./img/jinqiu.png"),
        },
      ],
    };
  },
  methods: {
    ...mapMutations(["toggleLogin"]),
    goBack() {
      this.$emit("closeFirstCharge");
    },
    updateGift() {
      post({
        url: "/api/activity/receiveRewards",
        data: { id: 2 },
      }).then(({ data }) => {
        if (data.status === 0) {
          this.$emit("showToast", "领取成功");
        }
        this.$emit("updateUserBag");
      });
    },
    toCharge() {
      if (!this.userInfo.id) {
        this.toggleLogin();
      } else if (this.isReceive == 1) {
        this.updateGift();
      } else if (this.isReceive == 2) {
        this.$emit("showUserCharge");
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
/deep/ {
  .el-dialog {
    border: 8px;
    overflow: hidden;
    border-radius: 10px;
  }
  .el-dialog__header {
    padding: 0;
  }
  .el-dialog__headerbtn {
    z-index: 10;
  }
  .el-dialog__headerbtn .el-dialog__close {
    color: #ffffff;
    background: rgba(0, 0, 0, 0.6);
    padding: 3px;
    border-radius: 50%;
    font-size: 18px;
    font-weight: 900;
  }
  .el-dialog__body {
    padding: 0;
    padding-bottom: 16px;
    background-image: linear-gradient(180deg, #515ede 0%, #6a7beb 100%);
  }
}
.first-charge-wrapper {
  .first-charge {
    border-radius: 16px;
    position: relative;
    margin: 0 auto;

    .back {
      width: 30px;
      height: 30px;
      position: absolute;
      top: 20px;
      right: 20px;
      border: 1px solid #fff;
      border-radius: 50%;
      color: #fff;
      font-size: 24px;
      text-align: center;
      line-height: 30px;
      z-index: 3007;
      cursor: pointer;
    }

    .top {
      width: 100%;
      height: 580px;
      background: url("./img/shouch_beijing.png") no-repeat;
      background-size: contain;
      position: relative;
      border-radius: 16px 16px 0 0;
    }

    .top-title {
      width: 333px;
      position: absolute;
      top: 16px;
      left: 50%;
      transform: translateX(-50%);
    }

    .bg-liwu {
      width: 337px;
      position: absolute;
      top: 155px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 3018;
    }

    .first-charge-content {
      width: 268px;
      height: 246px;
      position: absolute;
      top: 288px;
      left: 50%;
      transform: translateX(-50%);
      background: #3946cc;
      border-radius: 8px;
      z-index: 3019;
    }

    .gift-area {
      width: 100%;
      display: flex;
      justify-content: center;
      margin-top: 49px;
    }

    .mr-20 {
      margin-right: 24px;
    }

    .gift-item {
      display: flex;
      justify-content: center;
      flex-direction: column;

      &:last-child {
        margin-right: 0;
      }
    }

    .gift-img-item {
      width: 56px;
      height: 56px;
      background: #ffffff;
      box-shadow: inset 0px -2px 3px 0px rgba(213, 87, 9, 0.4);
      border-radius: 4px;
      margin-bottom: 60px;
      position: relative;
    }

    .gift-img {
      width: 100%;
      height: 100%;
    }

    .gift-info {
      width: 88px;
      text-align: center;
      position: absolute;
      top: 64px;
      left: 50%;
      transform: translateX(-50%);
    }

    .gift-name {
      font-size: 14px;
      color: #ffffff;
      line-height: 20px;
    }

    .gift-num {
      font-size: 14px;
      color: #ffdc3c;
      font-weight: 500;
    }

    .activity-btn {
      width: 252px;
      height: 48px;
      margin: 0 auto;
      background: url("./img/share_button.png") no-repeat;
      background-size: cover;
      font-size: 18px;
      color: #b51801;
      text-align: center;
      font-weight: 500;
      line-height: 36px;
      cursor: pointer;
    }

    .activity-tips {
      width: 100%;
      text-align: center;
      line-height: 17px;
      font-size: 12px;
      color: rgba(255, 255, 255, 0.6);
    }

    .first-charge-rule {
      width: 340px;
      margin: 0 auto;
      padding: 16px;
      background: #5855db;
      box-shadow: inset 2px 2px 8px 0px rgba(3, 0, 134, 0.3);
      border-radius: 12px;
      margin-top: 16px;
    }

    .first-charge-rule-title {
      width: 144px;
      height: 32px;
      margin: 0 auto;
      background: #e3e2ff;
      text-align: center;
      line-height: 32px;
      border-radius: 8px;
      font-size: 16px;
      color: #2420db;
      font-weight: 500;
      position: relative;

      &::before {
        content: "";
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background: #5855db;
        position: absolute;
        top: 50%;
        left: 10px;
        transform: translateY(-50%);
      }

      &::after {
        content: "";
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background: #5855db;
        position: absolute;
        top: 50%;
        right: 10px;
        transform: translateY(-50%);
      }
    }

    .first-charge-rule-content {
      margin-top: 12px;
      opacity: 0.8;
      font-size: 14px;
      color: #ffffff;
      line-height: 20px;
    }
  }
}
</style>
